<template>
    <div>
        <el-container class="toolBar">
            <el-main style="overflow-y: hidden;padding-bottom: 10px">
                <div >
                    <el-form :inline="true" style="text-align: left;padding-left:10px;" label-width="100px">
                        <div>
                            <el-form-item label="凭证状态">
                                <el-select v-model="reviewState" placeholder="请选择凭证状态" style="width: 180px">
                                    <el-option label="未提交" value="未提交"></el-option>
                                    <el-option label="已提交" value="已提交"></el-option>
                                    <el-option label="审核中" value="审核中"></el-option>
                                    <el-option label="审核完成" value="审核完成"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="项目名称">
                                <el-input style="width: 180px" v-model="projectName" placeholder="双击选择项目名称" @click.native="selProject">
                                </el-input>
                            </el-form-item>
                            <el-form-item label="凭证号">
                                <el-input style="width: 180px" v-model="billNo" placeholder="请输入账单编号">
                                </el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button icon="el-icon-search" type="primary" size="medium" @click="search">
                                    查询
                                </el-button>
                            </el-form-item>
                        </div>
                        <div>
                            <el-form-item label="关联账单类型">
                                <el-select v-model="relaBillType" placeholder="请选择关联账单类型" style="width: 180px">
                                    <el-option label="全部" value=""></el-option>
                                    <el-option label="采购入库" value="采购入库"></el-option>
                                    <el-option label="采购入库退出" value="采购入库退出"></el-option>
                                    <el-option label="入库单" value="入库单"></el-option>
                                    <el-option label="入库退出单" value="入库退出单"></el-option>
                                    <el-option label="送货单" value="送货单"></el-option>
                                    <el-option label="退货单" value="退货单"></el-option>
                                    <el-option label="费用单" value="费用单"></el-option>
                                    <el-option label="营业外收入" value="营业外收入"></el-option>
                                    <el-option label="营业外支出" value="营业外支出"></el-option>
                                    <el-option label="采购付款" value="采购付款"></el-option>
                                    <el-option label="销售收款" value="销售收款"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="关联账单编号">
                                <el-input style="width: 180px" v-model="relaBillNo" placeholder="请输入账单编号">
                                </el-input>
                            </el-form-item>
                            <el-form-item label="凭证日期">
                                <el-date-picker
                                        v-model="billDate"
                                        size="medium"
                                        type="daterange"
                                        value-format="yyyy-MM-dd"
                                        format="yyyy-MM-dd"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期">
                                </el-date-picker>
                            </el-form-item>
                        </div>
                        <div>
                            <el-form-item label="会计科目">
                                <el-input style="width: 180px" v-model="accTitleName" placeholder="选择会计科目" readonly
                                          @click.native="clickAccTitle">
                                </el-input>
                            </el-form-item>
                            <el-form-item label="借贷方">
                                <el-select v-model="accTitleKind" placeholder="请选择借贷方" style="width: 180px">
                                    <el-option label="借方" value="借方"></el-option>
                                    <el-option label="贷方" value="贷方"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="凭证摘要">
                                <el-input style="width: 180px" v-model="summary" placeholder="请输入凭证摘要"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button icon="el-icon-download" type="primary" size="medium" @click="excel">
                                    导出
                                </el-button>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="Xdriver"></div>
            </el-main>
        </el-container>
        <selAccTitle v-if="showAccTitle"
                     :accTitleData="accTitleData"
                     @closeDialog="closeDialog"
                     @checkRow="checkAccTitle">
        </selAccTitle>
        <selProject v-if="showProject"
                 :projectId="projectId"
                 @closeDialog="closeDialog"
                 @checkRow="checkProject">
        </selProject>
    </div>
</template>

<script>
    import selAccTitle from '@/components/page/finance/accountingtitle/selAccTitle'
    import selProject from '@/components/page/project/selProject'

    export default {
        name: 'toolBar',
        props: ['menuId', 'toolHeight', 'loading'],
        components: {
            selProject,selAccTitle
        },
        data() {
            return {
                searBarHeight: 70,

                showAccTitle:false,
                showProject:false,
                billNo:"",
                relaBillNo:"",
                relaBillType:"",
                billDate:[],
                projectId:"",
                projectName:"",
                reviewState:"",
                accTitleName:"",
                accTitleKind:"",
                summary:""
            }
        },
        methods: {
            closeDialog() {
                this.showAccTitle = false;
                this.showProject = false;
            },
            selProject(){
                this.showProject = true;
            },
            checkProject(row) {
                this.projectId=row.projectId;
                this.projectName = row.projectName;
                this.showProject = false;
            },
            checkAccTitle(row){
                this.accTitleName = row.name
                this.showAccTitle = false;
            },
            clickAccTitle(){
                this.accTitleName = this.name
                this.showAccTitle = true;
            },
            search() {

                let startDate = "";
                let endDate = "";
                if(this.billDate && this.billDate.length>0){
                    startDate = this.billDate[0];
                    endDate = this.billDate[1];
                }
                let searchData = {
                    startDate:startDate,
                    endDate:endDate,
                    reviewState:this.reviewState,
                    billNo:this.billNo,
                    relaBillNo:this.relaBillNo,
                    relaBillType:this.relaBillType,
                    projectId:this.projectId,
                    projectName:this.projectName,
                    accTitleKind:this.accTitleKind,
                    summary:this.summary,
                    accTitleName:this.accTitleName
                }
                this.$emit('search',searchData);
            },
            excel() {
                let startDate = "";
                let endDate = "";
                if(this.billDate && this.billDate.length>0){
                    startDate = this.billDate[0];
                    endDate = this.billDate[1];
                }
                let searchData = {
                    startDate:startDate,
                    endDate:endDate,
                    reviewState:this.reviewState,
                    billNo:this.billNo,
                    relaBillNo:this.relaBillNo,
                    relaBillType:this.relaBillType,
                    projectId:this.projectId,
                    projectName:this.projectName,
                    accTitleKind:this.accTitleKind,
                    summary:this.summary,
                    accTitleName:this.accTitleName
                }
                this.$emit('excel',searchData);
            }
        }
    }
</script>

